import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NfcRead from './nfc/NfcRead';
import NfcChat from './nfc/NfcChat';
import NfcRedirect from './nfc/NfcRedirect';
import AuthPage from './authPage/authPage';
import TopUp from './userCenter/topUp';
import UserCenter from './userCenter/userCenter';
import './App.css';
import TokenHistory from './userCenter/tokenHistory';
import FortuneHistory from './userCenter/fortuneHistory';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/nfc/tarot/read" replace />} />
        <Route path="*" element={<Navigate to="/nfc/tarot/read" replace />} />
        <Route path="/topup" element={<TopUp />} />
        <Route path="/userCenter" element={<UserCenter />} />
        <Route path="/tokenHistory" element={<TokenHistory />} />
        <Route path="/fortuneHistory" element={<FortuneHistory />} />
        <Route path="/authPage" element={<AuthPage />} />
        <Route path="/nfc/:cardType/read" element={<NfcRead />} />
        <Route path="/nfc/:cardType/chat" element={<NfcChat />} />
        <Route path="/d/:cardType/:cardName/:cardPosition" element={<NfcRedirect />} />
        <Route path="/d/:cardType" element={<NfcRedirect />} />

      </Routes>
    </div>
  );
}

export default App;
